import { Button, Checkbox, Divider, Input } from "antd";
import { CheckboxValueType } from "antd/lib/checkbox/Group";
import { ColumnFilterElementTemplateOptions } from "primereact/column";
import React, { useMemo, useState } from "react";
const CheckboxGroup = Checkbox.Group;
type Props = {
  datasource: any[];
  onChange: (list: Array<CheckboxValueType>) => void;
  checkList: CheckboxValueType[];
};

const CheckboxGroupSelelect = ({ datasource, checkList, onChange }: Props) => {
  const [searchValue, setSearchValue] = useState<string>("");

  const checkOptions = useMemo(
    () => Array.from(new Set(datasource.map((e) => (e ? e.toString() : "")))),
    [datasource]
  );

  const isCheckAll =
    checkOptions.length > 0 && checkList.length === checkOptions.length;

  return (
    <>
      <Input
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
      />

      <Checkbox
        checked={isCheckAll}
        indeterminate={
          checkList.length > 0 && checkList.length < checkOptions.length
        }
        onChange={(e) => {
          const checked = e.target.checked;
          onChange(checked ? checkOptions : []);
        }}
      >
        Select All
      </Checkbox>

      <Divider style={{ margin: 5 }} />

      <CheckboxGroup
        value={checkList}
        onChange={onChange}
        options={checkOptions.filter((e) =>
          e.toLowerCase().includes(searchValue.toLowerCase())
        )}
        style={{
          paddingLeft: 20,
          display: "flex",
          flexDirection: "column",
          overflowY: "scroll",
          maxHeight: "20vh",
        }}
      />
      
      {/* <div className="ant-table-filter-dropdown-btns" style={{ padding: 5 }}>
        <div></div>
        <Button
          size="middle"
          type="primary"
          onClick={() => {
            onChange(checkedList);
          }}
        >
          Ok
        </Button>
      </div> */}
    </>
  );
};

export default CheckboxGroupSelelect;
